<template lang="pug">
  yz-badge(:size="size" :color="statusColor" :text-color="statusTextColor" :border="status === 'cancelled'" :border-color="status === 'cancelled' ? 'yz-neutral-300' : null" style="padding: 2px 5px")
    yz-dot(v-if="status !== 'cancelled'" :color="statusDotColor" :size="dotSize" :style="dotMarginStyle")
    span.capitalize {{ translatedStatus }}
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: undefined
    },
    dotSize: {
      type: String,
      default: undefined
    }
  },
  computed: {
    translatedStatus() {
      const statusMap = {
        submitted: this.$t('panel.status_submitted'),
        rejected: this.$t('panel.status_rejected'),
        approved: this.$t('panel.status_approved'),
        received: this.$t('panel.status_received'),
        pending: this.$t('panel.status_pending'),
        overdue: this.$t('panel.status_overdue'),
        cancelled: this.$t('panel.status_cancelled')
      }
      return statusMap[this.status] || this.status
    },
    statusColor() {
      const statusColors = {
        submitted: '#FFF7D9',
        rejected: '#FFEBEB',
        approved: '#F0F8FF',
        received: '#EEFCE9',
        cancelled: 'yz-neutral-200'
      }
      return statusColors[this.status] || 'neutral-200'
    },
    statusDotColor() {
      const statusColors = {
        submitted: '#F2BE37',
        rejected: '#F04438',
        approved: '#0C6DFF',
        received: '#14AE5C',
        cancelled: 'yz-neutral-200'
      }
      return statusColors[this.status] || 'neutral-200'
    },
    statusTextColor() {
      const textColors = {
        submitted: '#CA6C16',
        rejected: '#B52222',
        approved: '#3570CA',
        received: '#1A7935',
        cancelled: 'yz-neutral-500'
      }
      return textColors[this.status] || 'neutral-500'
    },
    dotMarginStyle() {
      // Use ml-2 class for small size, inline style for default
      return this.size === 'sm' ? undefined : 'margin-right: 6px;'
    }
  }
}
</script>

<style scoped>
/* Add ml-2 spacing for small badges */
.yz-badge--sm .yz-dot {
  margin-left: 0;
  margin-right: 8px;
}
</style>
